<template>
  <section class="sec-more" data-anchor="MORE" v-block="block_carnival_more">
    <div class="more-wrapper">
      <div class="footer-title" />
      <div class="more-info">
        <div class="more-bd-qr"><img :src="moreInfo.bdQR" alt="" /></div>
        <div class="more-main">
          <div class="more-bada"><img :src="moreInfo.bd" alt="" /></div>
          <div class="more-manhua"><img :src="moreInfo.mh" alt="" /></div>
        </div>
        <div class="more-mh-qr"><img :src="moreInfo.mhQR" alt="" /></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      block_carnival_more: 'block_carnival_more',
    }
  },
  props: {
    moreInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
}
</script>
<style lang="less">
.sec-more {
  position: relative;
  background: url('~@/assets/carnival2020/more_bg.png') no-repeat;
  background-size: 1920px auto;
  height: 640px;
  .footer-title {
    background-image: url('~@/assets/carnival2020/more_title.png');
  }
  .more-wrapper {
    position: relative;
    top: 100px;
    width: 1101px;
    margin: 0 auto;
  }
  .more-info {
    display: flex;
    margin-top: 40px;
  }
  .more-main {
    width: 630px;
    margin-left: 14px;
    margin-right: 21px;
  }
  .more-bada,
  .more-manhua,
  .more-bd-qr,
  .more-mh-qr {
    background-repeat: no-repeat;
    background-size: contain;
    img {
      width: 100%;
    }
  }
  .more-bada,
  .more-manhua {
    width: 519px;
    height: 124px;
  }
  .more-bd-qr,
  .more-mh-qr {
    width: 218px;
    height: 270px;
    font-size: 27px;
    text-align: center;
    color: #ffffff;
  }
  .more-bada {
    margin-bottom: 22px;
  }
  .more-manhua {
    position: relative;
    left: 115px;
  }
}
</style>
